export { isInTimeCheck, isInTimeMs } from "./isInTimeCheck";

export const secondDiff = (
  unix1: number,
  unix2: number,
  diffCheck?: number
) => {
  const diff = unix2 - unix1;

  if (diffCheck) {
    if (diff >= diffCheck) {
      return true;
    }
    return false;
  } else {
    return diff;
  }
};

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};
